

import { pageSizes, pickerOptionsToday, PAY_TYPE_OPTIONSS } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { setToday } from '@/utils/filter';
import { BigNumber } from 'bignumber.js';
import setUrl from '@/mixins/setUrl';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });
export default {
  name: 'wait-fee',
  mixins: [pageSize, setUrl],
  data() {
    return {
      pageSizes,
      pickerOptionsToday,
      isChangeDate: false,
      payTypes: PAY_TYPE_OPTIONSS,
      statTypes: [{
        value: 0,
        label: '全部',
      }, {
        value: 1,
        label: '收款',
      }, {
        value: 2,
        label: '退款',
      }, {
        value: 3,
        label: '还款',
      }],
      streamInfo: {
        netIncome: 0, // 净收入
        actualAmount: 0, // 实收金额
        payModeCash: 0, // 现金
        payModeAlipay: 0, // 支付宝
        payModeWeixin: 0, // 微信
        payModeBankCard: 0, // 银行卡
        payModeMedicalInsurance: 0, // 医保
        payModeCommercialInsurance: 0, // 商保
        payModeBalance: 0, // 余额
        payModeRest: 0, // 其它
      },
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      query: {
        doctorId: null,
        payMode: 0,
        type: 0,
        patient: '', // 患者姓名
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      doctorOptions: [{
        doctorId: null,
        realName: '全部',
      }],
    };
  },
  methods: {
    // 获取列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      this.queryChangeHandle();
      this.$api.statistic.listDetailed(this.query).then((res) => {
        console.log(res);
        this.tableData = res.list;
        this.total = res.totalSize;
      });
      this.getTableDataToday();
    },
    // 获取列表信息-当日
    getTableDataToday() {
      this.$api.statistic.getCurrentDayData(this.query).then((res) => {
        this.streamInfo = res;
      });
    },
    // 获取诊所医生
    getDoctors() {
      this.$api.statistic.getDoctors().then((res) => {
        this.doctorOptions = [...this.doctorOptions, ...res];
      });
    },
    // 跳转收费详情
    gotoFeeDetail(item) {
      this.$router.push({ path: '/statistics/feeDetail', query: { id: item, isEdit: 0 } });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getTableData();
    },
    // 计算实际支出
    getExpend(actualAmount, netIncome) {
      return BN(Number(actualAmount)).minus(Number(netIncome)).toFixed(3);
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        time: this.time,
        doctorId: this.query.doctorId,
        payMode: this.query.payMode,
        type: this.query.type,
        patient: this.query.patient,
        currentPage: this.query.currentPage,
      });
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.time = queryUrl.time ? queryUrl.time : setToday();
      this.query.doctorId = queryUrl.doctorId ? Number(queryUrl.doctorId) : null;
      this.query.payMode = queryUrl.payMode ? Number(queryUrl.payMode) : 0;
      this.query.type = queryUrl.type ? Number(queryUrl.type) : 0;
      this.query.patient = queryUrl.patient ? queryUrl.patient : '';
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
      this.getTableData();
    },
  },
  mounted() {
    this.getDoctors();
    this.initQuery();
  },
  filters: {
    getOperateType(type) {
      let opType = '';
      switch (type) {
        case 1: opType = '收款';
          break;
        case 2: opType = '退款';
          break;
        case 3: opType = '还款';
          break;
        default: opType = '';
          break;
      }
      return opType;
    },
  },
};
